export default "__VITE_ASSET__DJ$STFKz__"